import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  citys: [],
  allCitys: [],
  totalPages: 0,
  totalRecords: 0,
  city: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_13: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Citys(state, citys) {
    state.citys = citys.items;
    state.totalPages = citys.totalPages;
    state.totalRecords = citys?.totalRecords ?? 0;
  },
  SET_AllCitys(state, citys) {
    state.allCitys = citys;
  },
  SET_City(state, city) {
    state.city = city;
  },
};
const actions = {
  errorCity({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllCitys({ commit, dispatch, rootState }) {
    return apiClient
      .get('/cities/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllCitys', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCity', error);
      });
  },
  addCity({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/cities', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCity', error);
      });
  },
  getCity({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/cities/ById?cityId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_City', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCity', error);
      });
  },
  editCity({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/cities/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCity', error);
      });
  },
  deleteCity({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/cities/Remove?cityId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCity', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
